import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, Icon } from '@alucio/lux-ui';
const styles = StyleSheet.create({
    icon: {
        width: 80,
        height: 80,
        color: 'rgba(255,255,255,0.4)',
    },
});
export default function ParticipantPlaceholder(props) {
    return (React.createElement(DNABox, { fill: true, alignY: "center", alignX: "center" },
        React.createElement(Icon, { style: [styles.icon, props.placeholderIconStyle], name: "account" })));
}
//# sourceMappingURL=ParticipantPlaceholder.js.map